import { createContext } from "react";

export const CompanyMilestonesModalContext = createContext();